var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCenter = function SvgIconCenter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1A1F",
    d: "M4.15 20.904 3.096 19.85l3.35-3.35H3.5V15H9v5.5H7.5v-2.946zm15.7 0-3.35-3.35V20.5H15V15h5.5v1.5h-2.946l3.35 3.35zM3.5 9V7.5h2.946l-3.35-3.35L4.15 3.097l3.35 3.35V3.5H9V9zM15 9V3.5h1.5v2.947l3.35-3.35 1.054 1.053-3.35 3.35H20.5V9z"
  })));
};
export default SvgIconCenter;